<template>
  <fragment>
    <!-- CONTACT FORM START -->
    <v-container class="my-5">
      <v-row>
        <v-col cols="12">
          <v-card style="overflow: hidden;" elevation="3">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" class="pa-0">
                  <v-img :src="`${publicPath}images/xiaomi-orange-bg.jpg`" class="align-stretch" cover
                         height="100%" aspect-ratio="1.333" position="center center">
                    <div class="d-flex flex-column justify-space-around" style="height: 100%;">
                      <div class="mx-auto text-center">
                        <div class="mx-auto" style="width: 140px; height: 140px;">
                          <v-img :src="`${publicPath}images/logo/xiaomi-white.png`" width="140" height="140" />
                        </div>
                        <div class="text-center">
                          <a href="https://www.mi.com/global/service/warranty" target="_blank" style="color: #FFFFFF;">{{ $t('moreInfosAboutTheService') }}</a>
                        </div>
                      </div>
                      <v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-email
                      </v-icon>
                      <div class="white--text text-center headline align-self-center">
                        {{ $t('ourEmail') }}:<br><a class="body-1 white--text">info@tmx.hu</a>
                      </div>
                      <v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-phone
                      </v-icon>
                      <div class="white--text text-center headline align-self-center">
                        {{ $t('ourPhoneNumber') }}:<br><a class="body-1 white--text">+36-1/58-58-381</a>
                      </div>
                    </div>
                  </v-img>
                </v-col>
                <v-col cols="12" md="7" class="px-10 py-12">
                  <v-form v-model="contactFormIsValid">
                    <v-row>
                      <v-col cols="12" md="6" class="py-2">
                        <v-autocomplete v-model="contactForm.brand"
                                        :items="selectFieldOptions.brands"
                                        :label="$t('inputLabels.manufacturer')"
                                        item-value="id"
                                        item-text="name"
                                        :rules="inputRules.generalRules"
                                        :hint="$t('inputMessages.requiredField')"
                                        persistent-hint
                                        outlined
                                        dense
                                        disabled
                                        return-object
                                        required>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.productType"
                                      :label="$t('inputLabels.productType')"
                                      :rules="inputRules.generalRules"
                                      outlined
                                      dense
                                      required
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.deviceIdentifier"
                                      :label="$t('inputLabels.imei')"
                                      :messages="$t(`${imeiHint}`)"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('imeiHint')"
                                      persistent-hint
                                      dense
                                      outlined
                                      required>
                        </v-text-field>
                        <div class="text-right">
                          <v-btn color="primary" small @click="imeiCheck">
                            {{ $t('button.validate') }}
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-select v-model="contactForm.simLock"
                                  :items="$i18n.locale === 'hu-HU' ? selectFieldOptions.simLock : $i18n.locale === 'de-DE' ? selectFieldOptions.simLockDE : selectFieldOptions.simLockEN"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('inputLabels.simLock')"
                                  :rules="inputRules.generalRules"
                                  :hint="$t('inputMessages.requiredField')"
                                  persistent-hint
                                  outlined
                                  dense
                                  return-object
                                  required>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-select v-model="contactForm.warrantyType"
                                  :items="$i18n.locale === 'hu-HU' ? selectFieldOptions.garancia : $i18n.locale === 'de-DE' ? selectFieldOptions.garanciaDE : selectFieldOptions.garanciaEN"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('inputLabels.warrantyType')"
                                  :rules="inputRules.generalRules"
                                  outlined
                                  dense
                                  disabled
                                  return-object
                                  required>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="contactForm.dateOfPurchase"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="contactForm.dateOfPurchase"
                              :label="$t('inputLabels.dateOfPurchase')"
                              :hint="$t('inputMessages.requiredField')"
                              :rules="inputRules.generalRules"
                              persistent-hint
                              outlined
                              dense
                              readonly
                              required
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="contactForm.dateOfPurchase"
                                         :first-day-of-week="1"
                                         :locale="$i18n.locale"
                                         :max="maxDate"
                                         min="2010-01-01">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false">{{ $t('button.cancel') }}</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog.save(contactForm.dateOfPurchase)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-textarea v-model="contactForm.troubleDescription"
                                    :label="$t('inputLabels.troubleDescription')"
                                    :rules="inputRules.generalRules"
                                    :hint="$t('inputMessages.requiredField')"
                                    persistent-hint
                                    outlined
                                    dense
                                    required>
                        </v-textarea>
                      </v-col>
                      <v-col cols="12" class="py-0 mb-5">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.customer.lastName"
                                      :label="$t('inputLabels.lastName')"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      counter="30"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.customer.firstName"
                                      :label="$t('inputLabels.firstName')"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      counter="30"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.customer.email"
                                      :label="$t('inputLabels.email')"
                                      :rules="inputRules.emailRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      counter="30"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.customer.phoneNumber"
                                      :label="$t('inputLabels.phone')"
                                      :rules="inputRules.phoneRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      prefix="+36-"
                                      v-mask="mask"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-0 mb-5">
                        <v-divider></v-divider>
                      </v-col>
                      <!-- CÍM ADATOK START -->
                      <v-col cols="12" md="6" class="py-2">
                        <v-autocomplete v-model="contactForm.customer.postalCode"
                                        :items="selectFieldOptions.postalCodes"
                                        item-text="address.postalCode"
                                        item-value="address.postalCode"
                                        :search-input.sync="postalCodeSearch"
                                        :label="$t('inputLabels.postalCode')"
                                        :rules="inputRules.phoneRules"
                                        :hint="$t('inputMessages.requiredField')"
                                        :no-data-text="$t('inputMessages.noDataText')"
                                        persistent-hint
                                        outlined
                                        maxlength="4"
                                        dense
                                        required
                                        @change="onPostalCodeSelect"
                                        @click:clear="clearAllAddressInputs"
                                        clearable>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-autocomplete v-model="contactForm.customer.city"
                                        :items="selectFieldOptions.cities"
                                        item-value="address.city"
                                        item-text="address.city"
                                        :search-input.sync="citySearch"
                                        :label="$t('inputLabels.city')"
                                        :rules="inputRules.generalRules"
                                        :hint="$t('inputMessages.requiredField')"
                                        :no-data-text="$t('inputMessages.noDataText')"
                                        persistent-hint
                                        outlined
                                        dense
                                        required
                                        clearable
                                        @click:clear="clearAllAddressInputs">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-combobox v-model="streetIdeiglenes"
                                    :items="selectFieldOptions.streets"
                                    item-value="address.street"
                                    item-text="address.street"
                                    :search-input.sync="streetSearch"
                                    :label="$t('inputLabels.publicPlaceName')"
                                    :rules="inputRules.generalRules"
                                    :hint="$t('inputMessages.requiredField')"
                                    :no-data-text="$t('inputMessages.noDataText')"
                                    persistent-hint
                                    outlined
                                    dense
                                    required
                                    @change="onPublicPlaceSelect"
                                    clearable>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.customer.streetNumber"
                                      :label="$t('inputLabels.streetNumber')"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      :no-data-text="$t('inputMessages.noDataText')"
                                      persistent-hint
                                      outlined
                                      dense
                                      required
                                      clearable>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-textarea v-model="contactForm.customer.other"
                                    :label="$t('inputLabels.other')"
                                    outlined
                                    maxlength="50"
                                    counter="50"
                                    dense
                                    required
                                    clearable>
                        </v-textarea>
                      </v-col>
                      <!-- CÍM ADATOK END -->
                      <v-col cols="12" class="py-0">
                        <v-checkbox
                          v-model="contactForm.gdpr"
                          :rules="inputRules.gdprRules"
                          required
                          class="ma-0"
                        >
                          <template slot="label">
                            <span v-show="$i18n.locale === 'hu-HU'" class="body-2">Az <a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Adatvédelmi tájékoztatót</a>&nbsp;elolvastam és elfogadom.</span>
                            <span v-show="$i18n.locale === 'en-EN'" class="body-2">I have read and accepted the&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Privacy Policy</a>.</span>
                            <span v-show="$i18n.locale === 'de-DE'" class="body-2">Ich habe die&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Datenschutzbestimmungen</a> gelesen und akzeptiere sie.</span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-checkbox
                          v-model="contactForm.termsAndCond"
                          :rules="inputRules.gdprRules"
                          required
                          class="ma-0"
                        >
                          <template slot="label">
                            <span v-show="$i18n.locale === 'hu-HU'" class="body-2">
                              Az&nbsp;<a :href="`${publicPath}doc/TMX_Terms_and_Conditions_hu.pdf`" target="_blank" @click.stop>Általános Szerződési Feltételeket</a>&nbsp;elolvastam és elfogadom.
                            </span>
                            <span v-show="$i18n.locale === 'en-EN'" class="body-2">
                              I have read and accepted the&nbsp;<a :href="`${publicPath}doc/TMX_Terms_and_Conditions_en.pdf`" target="_blank" @click.stop>Terms and Conditions</a>.
                            </span>
                            <span v-show="$i18n.locale === 'de-DE'" class="body-2">
                              Ich habe die&nbsp;<a :href="`${publicPath}doc/TMX_Terms_and_Conditions_de.pdf`" target="_blank" @click.stop>AGB</a> gelesen und akzeptiere sie.
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <v-row justify="end">
                          <v-btn rounded large color="primary" :disabled="!contactFormIsValid" @click="onButtonClick">
                            {{ $t('button.send') }}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- CONTACT FORM END -->
    <!-- RESPONSE DIALOGS START -->
    <v-dialog v-model="loadingDialog.visible" width="90%" max-width="340" :persistent="true">
      <loading-dialog v-bind:loading-message="loadingDialog.message" />
    </v-dialog>
    <v-dialog v-model="responseDialog.visible" width="90%" max-width="340" :persistent="true">
      <response-dialog v-bind:response-object="responseDialog.response"
                       v-on:close-dialog="closeResponseDialog"/>
    </v-dialog>
    <v-dialog v-model="noFileDialog.visible" width="90%" max-width="340" :persistent="true">
      <response-dialog v-bind:response-object="noFileDialog.response"
                       v-on:close-dialog="closeNoFileDialog"/>
    </v-dialog>
    <!-- RESPONSE DIALOGS END -->
    <!-- APPLE DIALOG START -->
    <v-dialog v-model="appleDialog" width="90%" max-width="540" :persistent="true">
      <v-card>
        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12">
              <div class="body-1">
                <p>Tisztelt Ügyfelünk!</p>
                <p>Szeretnénk felhívni figyelmét, hogy a Apple iPhone készülékek javítását a szakszerviz akkor tudja megkezdeni, ha az
                  <span class="font-weight-bold"> iPhone követése szolgáltatás (Find my iPhone – FMI) ki van kapcsolva</span> a készüléken!</p>
                <p>Köszönjük!</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendContactForm">
            Rendben
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- APPLE DIALOG END -->
  </fragment>
</template>

<script>
import dayjs from 'dayjs';
import { SEND_REPAIR_FORM, LUHN_CHECK } from '../store/actions.type';
import responseDialog from './responseDialog.vue';
import loadingDialog from './loadingDialog.vue';
import {
  HEREGETCOUNTRY,
  HEREGETPOSTALCODESBYCOUNTRY,
  HEREGETCITYBYPOSTALCODE,
  HEREGETSTREETBYPOSTALCODE,
  HEREGETCITYBYCOUNTRY,
  HEREGETPOSTALCODESBYCITY,
  HEREGETPOSTALCODESBYCITYLIVE,
} from '../utils/hereAPI';

export default {
  name: 'mobilfutarXiaomiForm',
  props: {
    formBackgroungImage: String,
    formLogo: String,
    linkTo: String,
  },
  components: {
    responseDialog, loadingDialog,
  },
  beforeMount() {
    const now = new Date();
    const date = dayjs(now).subtract(3, 'day');
    this.maxDate = date.toISOString().substr(0, 10);
    this.contactForm.brand = this.$store.state.generalStore.brands[103];
    if (this.$i18n.locale === 'hu-HU') {
      this.contactForm.warrantyType = this.$store.state.generalStore.warrantyType[0];
      this.contactForm.customer.country = this.selectFieldOptions.countries[0];
    } else if (this.$i18n.locale === 'de-DE') {
      this.contactForm.warrantyType = this.$store.state.generalStore.warrantyTypeDE[0];
      this.contactForm.customer.country = this.selectFieldOptions.countriesDE[0];
    } else {
      this.contactForm.warrantyType = this.$store.state.generalStore.warrantyTypeEN[0];
      this.contactForm.customer.country = this.selectFieldOptions.countriesEN[0];
    }
  },
  mounted() {
    // this.contactForm.sourceSystem = this.$route.name.substring(14);
  },
  data() {
    return {
      mask: '##-###-####',
      modal: false,
      contactFormIsValid: false,
      contactFormCheckbox: false,
      imeiHint: '',
      maxDate: null,
      appleDialog: false,
      loadingDialog: {
        visible: false,
        message: 'loadingMessages.INPROGRESS_CONTACT_FORM',
      },
      responseDialog: {
        visible: false,
        response: {
          error: false,
          data: [],
          message: 'successMessages.SUCCESS_REPAIR_FORM',
        },
      },
      noFileDialog: {
        visible: false,
        response: {
          error: false,
          data: [],
          message: 'errorMessages.ERROR_AT_LEAST_ONE_FILE',
        },
      },
      contactForm: {
        insuranceNumber: '',
        sourceSystem: 'TMX-XIAOMI',
        brand: this.$store.state.generalStore.brandsTMX[8],
        productType: '',
        productTypeId: 0,
        deviceIdentifier: '',
        warrantyType: null,
        dateOfPurchase: null,
        troubleDescription: '',
        simLock: {},
        customer: {
          title: '',
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          country: {},
          city: '',
          postalCode: '',
          publicPlaceName: '',
          publicPlaceType: '',
          streetNumber: '',
          other: '',
        },
        gdpr: false,
        termsAndCond: false,
        examinationFee: true,
      },
      attachment: {
        invoice: [],
        warrantyCard: [],
      },
      countrySearch: '',
      countrySearchIsLoading: false,
      postalCodeSearch: '',
      postalCodeSearchIsLoading: false,
      citySearch: '',
      citySearchIsLoading: false,
      streetSearch: '',
      streetSearchIsLoading: false,
      streetIdeiglenes: '',
      selectFieldOptions: {
        brands: this.$store.state.generalStore.brandsTMX,
        garancia: this.$store.state.generalStore.warrantyType,
        garanciaEN: this.$store.state.generalStore.warrantyTypeEN,
        garanciaDE: this.$store.state.generalStore.warrantyTypeDE,
        simLock: this.$store.state.generalStore.simLock,
        simLockEN: this.$store.state.generalStore.simLockEN,
        simLockDE: this.$store.state.generalStore.simLockDE,
        countries: [
          { label: 'Magyarország', countryCode: 'HUN' },
        ],
        countriesEN: [
          { label: 'Hungary', countryCode: 'HUN' },
        ],
        countriesDE: [
          { label: 'Ungarn', countryCode: 'HUN' },
        ],
        postalCodes: [
          { header: this.$t('inputMessages.startTypingPostalCode') },
        ],
        cities: [
          { header: this.$t('inputMessages.startTypingCity') },
        ],
        streets: [
          { header: this.$t('inputMessages.startTypingStreet') },
        ],
      },
      inputRules: {
        generalRules: [v => !!v || this.$t('inputMessages.requiredField')],
        emailRules: [
          v => /.+@.+\..+/.test(v) || this.$t('inputMessages.emailMatch'),
          v => !!v || this.$t('inputMessages.requiredField'),
        ],
        phoneRules: [
          v => /^[0-9\-]*$/.test(v) || this.$t('inputMessages.onlyNumbers'),
          v => !!v || this.$t('inputMessages.requiredField'),
        ],
        gdprRules: [
          v => !!v || this.$t('inputMessages.requiredPrivacy'),
        ],
        termAndCondRules: [
          v => !!v || this.$t('inputMessages.requiredTermsAndCond'),
        ],
        maxFileSize: [
          v => !v || v.size < 5000000 || this.$t('inputMessages.maxFileSizeRule'),
        ],
        requiredFile: [
          v => !v || v.size < 5000000 || this.$t('inputMessages.maxFileSizeRule'),
          v => !!v || this.$t('inputMessages.requiredField'),
        ],
      },
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {
    onButtonClick() {
      if (this.contactForm.brand.id === 27) {
        this.appleDialog = true;
      } else {
        this.sendContactForm();
      }
    },
    async sendContactForm() {
      // eslint-disable-next-line no-console
      // console.log('sending the form...');
      if (this.appleDialog) {
        this.appleDialog = false;
      }
      this.openLoadingDialog();
      const response = await this.$store.dispatch(SEND_REPAIR_FORM,
        { form: this.contactForm, attachment: this.attachment });
      switch (response) {
        case 200:
          break;
        case 201:
          break;
        case 400:
          this.setupResponseDialog('errorMessages.ERROR_GENERAL_FAIL');
          break;
        case 404:
          this.setupResponseDialog('errorMessages.ERROR_GENERAL_FAIL');
          break;
        case 500:
          this.setupResponseDialog('errorMessages.ERROR_GENERAL_FAIL');
          break;
        default:
          break;
      }
      this.controlDialogs();
    },
    openLoadingDialog() {
      this.loadingDialog.visible = true;
    },
    closeLoadingDialog() {
      this.loadingDialog.visible = false;
    },
    setupResponseDialog(message) {
      this.responseDialog.response.message = message;
    },
    openResponseDialog() {
      this.responseDialog.visible = true;
    },
    closeResponseDialog() {
      this.responseDialog.visible = false;
      this.$router.push('/');
    },
    closeNoFileDialog() {
      this.noFileDialog.visible = false;
    },
    controlDialogs() {
      setTimeout(this.closeLoadingDialog, 3000);
      setTimeout(this.openResponseDialog, 3200);
    },
    async imeiCheck() {
      const response = await this.$store.dispatch(LUHN_CHECK, this.contactForm.deviceIdentifier);
      if (response) {
        // console.log('LUHN_CHECK: ', response);
        if (response.error) {
          this.imeiHint = 'imeiError';
        } else {
          this.imeiHint = response.message;
        }
      }
    },
    /**
       * Ország API
       */
    async getCountries(value) {
      const response = await HEREGETCOUNTRY(value);
      if (!response.error) {
        this.selectFieldOptions.countries = response.data;
        this.countrySearchIsLoading = false;
      }
    },
    /**
       * Irányítószám ország alapján API
       */
    async getPostalCodesByCountry(value) {
      const response = await HEREGETPOSTALCODESBYCOUNTRY(value, this.contactForm.customer.country.countryCode);
      if (!response.error) {
        this.selectFieldOptions.postalCodes = response.data;
        this.postalCodeSearchIsLoading = false;
        this.selectFieldOptions.postalCodes.unshift({ header: this.$t('inputMessages.startTypingPostalCode') });
        /* if (this.selectFieldOptions.postalCodes.length === 1) {
            this.onPostalCodeSelect();
          } */
      }/* else {
        this.selectFieldOptions.postalCodes = [];
      } */
    },
    /**
       * Irányítószám város és ország alapján API
       */
    async getPostalCodesByCity(postalcode) {
      const response = await HEREGETPOSTALCODESBYCITYLIVE(postalcode, this.contactForm.customer.city, this.contactForm.customer.country.countryCode);
      if (!response.error) {
        this.selectFieldOptions.postalCodes = response.data;
        this.postalCodeSearchIsLoading = false;
        /* if (this.selectFieldOptions.postalCodes.length === 1) {
            this.onPostalCodeSelect();
          } */
      }
    },
    /**
       * Irányítószám város és ország alapján API
       */
    async getPostalCodesByCitySelect() {
      const response = await HEREGETPOSTALCODESBYCITY(this.contactForm.customer.city, this.contactForm.customer.country.countryCode);
      if (!response.error) {
        this.selectFieldOptions.postalCodes = response.data;
        this.postalCodeSearchIsLoading = false;
        /* if (this.selectFieldOptions.postalCodes.length === 1) {
            this.onPostalCodeSelect();
          } */
      }
    },
    /**
       * Város Irányítószám és ország alapján API
       */
    async getCityByPostalCode() {
      let postalcode = 0;
      if (this.contactForm.customer.postalCode.address) {
        postalcode = this.contactForm.customer.postalCode.address.postalCode;
        this.contactForm.customer.postalCode = postalcode;
      }
      const response = await HEREGETCITYBYPOSTALCODE(this.contactForm.customer.postalCode, this.contactForm.customer.country.countryCode);
      if (!response.error) {
        this.selectFieldOptions.cities = response.data;
        this.citySearchIsLoading = false;
        this.selectFieldOptions.cities.unshift({ header: this.$t('inputMessages.startTypingCity') });
      }
    },
    /**
       * Város ország alapján API
       */
    async getCityByCountry(city) {
      const response = await HEREGETCITYBYCOUNTRY(city, this.contactForm.customer.country.countryCode);
      if (!response.error) {
        this.selectFieldOptions.cities = response.data;
        this.citySearchIsLoading = false;
      }
    },
    /**
       * Utca API
       */
    async getStreetByPostalCode(value) {
      const response = await HEREGETSTREETBYPOSTALCODE(value, this.contactForm.customer.postalCode, this.contactForm.customer.country.countryCode);
      if (!response.error) {
        this.selectFieldOptions.streets = response.data;
        this.streetSearchIsLoading = false;
        this.selectFieldOptions.streets.unshift({ header: this.$t('inputMessages.startTypingStreet') });
      }
    },
    /**
       * Város autocomplete ha kiválasztottuk az irányítószámot
       */
    async onPostalCodeSelect() {
      await this.getCityByPostalCode();
      if (this.selectFieldOptions.cities.length === 2) {
        this.contactForm.customer.city = this.selectFieldOptions.cities[1].address.city;
        this.citySearch = this.selectFieldOptions.cities[1].address.city;
      }
      this.contactForm.customer.publicPlaceName = '';
      this.contactForm.customer.publicPlaceType = '';
      this.contactForm.customer.streetNumber = '';
      this.streetIdeiglenes = '';
      this.streetSearch = null;
    },
    onPublicPlaceSelect() {
      let street = '';
      let type = '';
      if (this.streetIdeiglenes.length > 0) {
        street = this.streetIdeiglenes.substring(0, this.streetIdeiglenes.lastIndexOf(' '));
        type = this.streetIdeiglenes.substring(this.streetIdeiglenes.lastIndexOf(' '), this.streetIdeiglenes.length + 1).trim();
      } else if (this.streetIdeiglenes.address) {
        street = this.streetIdeiglenes.address.street.substring(0, this.streetIdeiglenes.address.street.lastIndexOf(' '));
        type = this.streetIdeiglenes.address.street.substring(this.streetIdeiglenes.address.street.lastIndexOf(' '), this.streetIdeiglenes.address.street.length + 1).trim();
      }
      this.contactForm.customer.publicPlaceName = street;
      this.contactForm.customer.publicPlaceType = type;
    },
    clearAllAddressInputs() {
      this.selectFieldOptions.postalCodes = [
        { header: this.$t('inputMessages.startTypingPostalCode') },
      ];
      this.selectFieldOptions.cities = [
        { header: this.$t('inputMessages.startTypingCity') },
      ];
      this.selectFieldOptions.streets = [
        { header: this.$t('inputMessages.startTypingStreet') },
      ];
      this.postalCodeSearch = '';
      this.postalCodeSearchIsLoading = false;
      this.citySearch = '';
      this.citySearchIsLoading = false;
      this.streetSearch = '';
      this.streetSearchIsLoading = false;
      this.streetIdeiglenes = '';
      this.contactForm.customer.postalCode = '';
      this.contactForm.customer.city = '';
      this.contactForm.customer.publicPlaceType = '';
      this.contactForm.customer.publicPlaceName = '';
      this.contactForm.customer.streetNumber = '';
    },
  },
  watch: {
    /* countrySearch(value) {
        this.countrySearchIsLoading = true;
        this.getCountries(value);
      }, */
    postalCodeSearch(value) {
      this.postalCodeSearchIsLoading = true;
      this.getPostalCodesByCountry(value);
      // this.getPostalCodesByCity(value);
    },
    /* citySearch(value) {
        this.citySearchIsLoading = true;
        // this.getCityByPostalCode();
        this.getCityByCountry(value);
      }, */
    streetSearch(value) {
      this.streetSearchIsLoading = true;
      this.getStreetByPostalCode(value);
    },
  },
};
</script>

<style scoped>

</style>
